import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Swords, Check, X, Hourglass, Table2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminChallenges() {
  const [matches, setMatches] = useState([]);
  const [tables, setTables] = useState([]);
  const [assigning, setAssigning] = useState(null);

  const load = () => {
    api.get("/matches?status=pending_table&limit=50").then(({ data }) => setMatches(data));
    api.get("/tables").then(({ data }) => setTables(data));
  };
  useEffect(() => {
    load();
    const i = setInterval(load, 6000);
    return () => clearInterval(i);
  }, []);

  const assign = async (tableId) => {
    try {
      await api.post(`/matches/${assigning.id}/assign-table`, { table_id: tableId });
      toast.success("Đã gán bàn — trận bắt đầu!");
      setAssigning(null);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail); }
  };

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-display font-bold text-3xl mb-1 flex items-center gap-3"><Swords className="text-cyan-300" /> Trận chờ gán bàn</h1>
      <p className="text-white/40 text-sm mb-6">{matches.length} trận từ thách đấu cần gán bàn để bắt đầu</p>

      {matches.length === 0 ? (
        <div className="rounded-xl bg-[#0c0d14] border border-white/8 p-12 text-center text-white/40">Không có trận nào chờ gán bàn</div>
      ) : (
        <div className="space-y-3">
          {matches.map((m) => (
            <div key={m.id} className="rounded-xl bg-[#0c0d14] border border-cyan-400/20 p-4 flex items-center gap-4" data-testid={`pending-match-${m.id}`}>
              <Hourglass className="text-yellow-300" />
              <div className="flex-1 grid grid-cols-3 items-center gap-3 min-w-0">
                <div className="text-right truncate">
                  <div className="font-display font-semibold text-sm truncate">{m.player_a_nickname}</div>
                  <div className="text-[10px] text-white/40">{m.player_a_rank}</div>
                </div>
                <div className="text-center">
                  <div className="font-display font-bold text-xl text-white/40">VS</div>
                  <div className="text-[10px] text-white/50">BO{m.best_of} · {m.mode}</div>
                </div>
                <div className="truncate">
                  <div className="font-display font-semibold text-sm truncate">{m.player_b_nickname}</div>
                  <div className="text-[10px] text-white/40">{m.player_b_rank}</div>
                </div>
              </div>
              <button onClick={() => setAssigning(m)} data-testid={`assign-${m.id}`} className="px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-r from-cyan-400 to-purple-500 text-black flex items-center gap-2">
                <Table2 size={14} /> Gán bàn
              </button>
            </div>
          ))}
        </div>
      )}

      {assigning && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setAssigning(null)}>
          <div className="w-full max-w-md rounded-xl bg-[#0c0d14] border border-white/10 p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-semibold">Chọn bàn cho trận</h3>
              <button onClick={() => setAssigning(null)} className="p-1 hover:bg-white/5 rounded"><X size={16} /></button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {tables.map((t) => {
                const busy = t.status !== "free";
                return (
                  <button key={t.id} disabled={busy} onClick={() => assign(t.id)} data-testid={`assign-pick-${t.number}`}
                    className={`p-3 rounded-md border ${busy ? "border-white/5 bg-white/[0.02] text-white/30 cursor-not-allowed" : "border-cyan-400/30 bg-cyan-400/5 hover:bg-cyan-400/15 text-cyan-300"}`}>
                    <div className="font-display font-bold text-2xl">{t.number}</div>
                    <div className="text-[10px] mt-1">{t.status === "free" ? "Trống" : t.status === "playing" ? "Đang đấu" : "Bảo trì"}</div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
